import {Dispatch, MouseEventHandler, MouseEvent as ReactMouseEvent, useState} from 'react';

function useDrag({
  handleMove,
  onDragStart = () => {},
  onDragEnd = () => {},
  preventDefault = true,
}: {
  handleMove: Dispatch<MouseEvent>;
  onDragStart?: Dispatch<MouseEvent>;
  onDragEnd?: Dispatch<MouseEvent>;
  preventDefault?: boolean;
}): {handleDragStart: MouseEventHandler; isDragging: boolean} {
  const [isDragging, setIsDragging] = useState(false);

  function handleDragStart(e: ReactMouseEvent) {
    e.stopPropagation();
    preventDefault && e.preventDefault();
    onDragStart(e.nativeEvent);
    setIsDragging(true);

    function handleMouseUp(e: MouseEvent) {
      onDragEnd(e);
      setIsDragging(false);
      document.removeEventListener('mousemove', handleMove);
      document.removeEventListener('mouseup', handleMouseUp);
      document.removeEventListener('mouseleave', handleMouseUp);
    }

    document.addEventListener('mousemove', handleMove);
    document.addEventListener('mouseup', handleMouseUp);
    document.addEventListener('mouseleave', handleMouseUp);
  }

  return {handleDragStart, isDragging};
}

export default useDrag;
